import React, { useState, useEffect } from 'react';
import {
	GridItem,
	Box,
	Text,
	Accordion,
	AccordionItem,
	AccordionButton,
	AccordionPanel,
	AccordionIcon,
	Link,
	UnorderedList,
	ListItem,
} from '@chakra-ui/react';
import ReactMarkdown from 'react-markdown';
import { HeadingComponent } from './Heading';

const FAQType: Record<string, string> = {
	general: 'General Questions',
	isa: 'Pay After Placement (PAP) Questions',
	application: 'Application Questions',
	placement: 'Placement Questions',
};

interface FaqsProps {
	faqs: any;
	selectedCategory?: string;
	uniqueTypes: string[];
	showHeader?: boolean;
	hasSpacing?: boolean;
}
const Faqs = ({ faqs, selectedCategory = '', uniqueTypes, showHeader = true, hasSpacing = true }: FaqsProps) => {
	const [filterOptions, setFilterOptions] = useState<string[]>(uniqueTypes);
	useEffect(() => {
		if (selectedCategory) {
			setFilterOptions(uniqueTypes.filter(filter => filter === selectedCategory));
		} else {
			setFilterOptions(uniqueTypes);
		}
	}, [selectedCategory, faqs, uniqueTypes]);

	return (
		<GridItem colSpan={{ base: 12, md: 7 }}>
			{filterOptions?.map((type: string, idx: number) => {
				return (
					<Box
						key={idx}
						width={{ base: '100%', md: 'auto' }}
						margin={{ md: 'auto' }}
						marginTop={{
							base: idx === 0 ? '0px' : hasSpacing ? '48px' : '0px',
							md: idx === 0 ? '0px' : filterOptions.length > 1 ? '0px' : '32px',
						}}
					>
						{showHeader && <HeadingComponent idx={idx} type={type} heading={FAQType[type]} />}
						{faqs
							.filter((faq: any) => (selectedCategory ? faq.questionType === selectedCategory : true))
							.filter((faq: any) =>  faq.questionType === type)
							.map((faq: any, index: number) => (
								<Box key={faq.id || index}>
									<Accordion allowToggle borderTop="0px solid white">
										<AccordionItem key={faq.id}>
											<Text>
												<AccordionButton padding="16px">
													<Box
														flex="1"
														textAlign="left"
														fontWeight={600}
														fontSize="ms-14"
														color={{
															base: 'ms-gray.800',
															md: 'ms-red.900',
														}}
														lineHeight="ms-22"
														paddingRight="1.875rem"
													>
														{faq.question}
													</Box>
													<AccordionIcon />
												</AccordionButton>
											</Text>
											<AccordionPanel pb={4} fontWeight={400} fontSize="ms-14" lineHeight="ms-22" color="ms-gray.700">
												<ReactMarkdown
													components={{
														a: (props: any) => {
															return (
																<Link href={props.href} textColor="ms-blue.500" textDecoration="underline">
																	{props.children}
																</Link>
															);
														},
														ul: (props: any) => {
															return <UnorderedList pl={5}>{props.children} </UnorderedList>;
														},
														li: (props: any) => {
															return (
																<ListItem>
																	<Text>{props.children}</Text>
																</ListItem>
															);
														},
													}}
												>
													{faq.answer}
												</ReactMarkdown>
											</AccordionPanel>
										</AccordionItem>
									</Accordion>
								</Box>
							))}
					</Box>
				);
			})}
		</GridItem>
	);
};

export default Faqs;
